import styled from "styled-components"

export const Wrapper = styled.div`
   display: flex;
   width: 100%;
   justify-content: center;
   align-items: center;
   font-size: 3rem;
`

export const Container = styled.div`
   position: fixed;
   bottom: 24px;
   left: 50%;
   transform: translateX(-50%);
   z-index: 2000;
   display: flex;
   align-items: center;
   justify-content: center;
   color: var(--primary);
   cursor: pointer;

   &:hover {
      color: var(--secondary);
   }
`
